/* global BigInt */
let api = {}

api.required = (v) => {
    // window.console.log("validations::required>", v);
    if (v == null || "" === v) return window.__('mls.Validators.required') || "El valor es obligatorio.";

    return null;
}
api.minLength = (v, params) => {
    // window.console.log("validations::minLength>", v, params);
    if (v == null || "" === v || v.length < params.param)
        return window.__('mls.Validators.minLength') ? window.api.eval(window.__('mls.Validators.minLength'), api, params.param) : `El valor debe tener una longitud minima de ${params.param}.`;

    return null;
}

api.maxLength = (v, params) => {
    // window.console.log("validations::maxLength>", v, params);
    if (v == null || "" === v || v.length > params.param)
        return `El valor debe tener una longitud maxima de ${params.param}.`;

    return null;
}
api.maxMinLength = (v, params) => {
    // window.console.log("validations::minLength>", v, params);
    if (v == null || "" === v || v.length < params.min || v.length > params.max)
        return `El valor debe tener una longitud minima de ${params.min} y una longitud maxima de ${params.max}.`;

    return null;
}


api.startsWith = (v, params) => {
    // window.console.log("validations::startsWith>", v, params);
    if (v == null || "" === v || !v.toLowerCase().startsWith(params.param.toLowerCase()))
        return `El valor debe empezar por ${params.param}.`;

    return null;
}

api.includes = (v, params) => {
    // window.console.log("validations::includes>", v, params);
    if (v == null || "" === v || !v.toLowerCase().includes(params.param.toLowerCase()))
        return `El valor debe incluir la cadena ${params.param}.`;

    return null;
}

api.isEmail = (value) => {
    if (!value || "" === value) return null;
    /* eslint-disable */
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    /* eslint-enable */
    return re.test(value) ? null : 'El formato del email es incorrecto.';
}

api.isCIF = (cif) => {
    if (!cif || "" === cif) return null;

    let errMsg = "El CIF introducido es invalido.";

    if (!cif || cif.length !== 9) {
        return errMsg;
    }

    cif = cif.toUpperCase();

    var letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    var digits = cif.substr(1, cif.length - 2);
    var letter = cif.substr(0, 1);
    var control = cif.substr(cif.length - 1);
    var sum = 0;
    var i;
    var digit;

    if (!letter.match(/[A-Z]/)) {
        return errMsg;
    }

    for (i = 0; i < digits.length; ++i) {
        digit = parseInt(digits[i]);

        if (isNaN(digit)) {
            return errMsg;
        }

        if (i % 2 === 0) {
            digit *= 2;
            if (digit > 9) {
                digit = parseInt(digit / 10) + (digit % 10);
            }

            sum += digit;
        } else {
            sum += digit;
        }
    }

    sum %= 10;
    if (sum !== 0) {
        digit = 10 - sum;
    } else {
        digit = sum;
    }

    if (letter.match(/[ABEH]/)) {
        return String(digit) === control ? null : errMsg;
    }
    if (letter.match(/[NPQRSW]/)) {
        return letters[digit] === control ? null : errMsg;
    }

    return String(digit) === control || letters[digit] === control ? null : errMsg;
}
api.isNIF = (dni) => {
    let msgError = 'El formato del NIF es incorrecto.';

    if (!dni) return null;
    if (dni.length > 9) return msgError;
    dni = dni.toUpperCase()

    var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    var letter = dni_letters.charAt(parseInt(dni, 10) % 23);

    return ((letter == dni.charAt(7) && dni.length === 8) || (letter == dni.charAt(8) && dni.length === 9)) ? null : msgError;
}

api.isNIE = (value) => {
    // Change the initial letter for the corresponding number and validate as DNI
    var nie_prefix = value.charAt(0);

    switch (nie_prefix) {
        case 'X': nie_prefix = 0; break;
        case 'Y': nie_prefix = 1; break;
        case 'Z': nie_prefix = 2; break;
    }

    let errnif = api.isNIF(nie_prefix + value.substr(1))

    return !errnif ? null : 'El formato del documento es incorrecto.';
}

api.isNIFNIE = (dni) => {
    if (!dni) return null;

    let errnif = api.isNIF(dni);
    if (!errnif) return null

    let errnie = api.isNIE(dni);
    if (!errnie) return null

    return 'El formato del documento es incorrecto.';
}

api.isNIFNIECIF = (dni) => {
    if (!dni) return null;

    let errnif = api.isNIF(dni);
    if (!errnif) return null

    let errnie = api.isNIE(dni);
    if (!errnie) return null

    let errcif = api.isCIF(dni);
    if (!errcif) return null

    return 'El formato del documento es incorrecto.';
}

/**
 * Valida cuentas bancarias españolas (IBAN ES o CCC de 20 dígitos).
 * @param {string} input - IBAN español (p.ej. "ES91 2100 0418 4502 0005 1332") o CCC (20 dígitos).
 * @returns {{valid:boolean, type:'IBAN'|'CCC'|null, normalized:string, reason?:string}}
 */
api.isIBAN_CCC = (input) => {
    const raw = String(input || '').trim();
    const normalized = raw.replace(/[\s-]+/g, '').toUpperCase();

    if (!normalized) {
        // return { valid: false, type: null, normalized, reason: 'Vacío' };
        return 'IBAN de longitud insuficiente'
    }

    // --- IBAN español ---
    if (/^ES[0-9A-Z]+$/.test(normalized)) {
        // IBAN ES debe tener 24 caracteres: ES + 22 alfanuméricos
        if (normalized.length !== 24) {
            // return { valid: false, type: 'IBAN', normalized, reason: 'Longitud IBAN ES inválida (debe ser 24)' };
            return 'Longitud IBAN ES inválida (debe ser 24)'
        }
        const isValid = validateIbanES(normalized);
        /*
        return {
            valid: isValid,
            type: 'IBAN',
            normalized,
            reason: isValid ? undefined : 'Control IBAN (módulo 97) incorrecto'
        };
        */
       return isValid ? null : 'Control IBAN (módulo 97) incorrecto'
    }

    // --- CCC (20 dígitos) ---
    if (/^\d{20}$/.test(normalized)) {
        const isValid = validateCCC(normalized);
        /*
        return {
            valid: isValid,
            type: 'CCC',
            normalized,
            reason: isValid ? undefined : 'Dígitos de control del CCC incorrectos'
        };
        */
       return isValid ? null : 'Dígitos de control del CCC incorrectos'
    }

    /* ===== Helpers ===== */

    // IBAN ES: mover 4 primeras a la cola, sustituir letras A=10..Z=35, mod 97 == 1
    function validateIbanES(iban) {
        if (!iban.startsWith('ES')) return false;
        const rearranged = iban.slice(4) + iban.slice(0, 4);
        const numeric = rearranged.replace(/[A-Z]/g, ch => (ch.charCodeAt(0) - 55).toString()); // A=10 ... Z=35
        return mod97(numeric) === 1n;
    }

    // Módulo 97 sobre string grande (con BigInt)
    function mod97(numStr) {
        let rem = 0n;
        for (let i = 0; i < numStr.length; i++) {
            const c = numStr[i];
            if (c < '0' || c > '9') return -1n; // carácter inesperado
            rem = (rem * 10n + BigInt(c.charCodeAt(0) - 48)) % 97n;
        }
        return rem;
    }

    // CCC: 20 dígitos => BBBB SSSS DC CCCCCCCCCC
    // DC1 valida banco+sucursal con pesos [4,8,5,10,9,7,3,6]
    // DC2 valida cuenta con pesos    [1,2,4,8,5,10,9,7,3,6]
    function validateCCC(ccc) {
        if (!/^\d{20}$/.test(ccc)) return false;

        const bancoSucursal = ccc.slice(0, 8);
        const dc = ccc.slice(8, 10);
        const cuenta = ccc.slice(10);

        const dc1 = computeCCCCheckDigit(bancoSucursal, [4, 8, 5, 10, 9, 7, 3, 6]);
        const dc2 = computeCCCCheckDigit(cuenta, [1, 2, 4, 8, 5, 10, 9, 7, 3, 6]);

        return dc === `${dc1}${dc2}`;
    }

    function computeCCCCheckDigit(numberStr, weights) {
        let sum = 0;
        for (let i = 0; i < weights.length; i++) {
            sum += parseInt(numberStr[i], 10) * weights[i];
        }
        let rem = sum % 11;
        let digit = 11 - rem;
        if (digit === 10) digit = 1;
        if (digit === 11) digit = 0;
        return digit;
    }


    return { valid: false, type: null, normalized, reason: 'Formato no reconocido (use IBAN ES o CCC de 20 dígitos)' };
}


/*
 console.log(validateSpanishBankAccount('ES91 2100 0418 4502 0005 1332'));
*/


export default api;